module.exports = __webpack_public_path__ + "static/media/atlantic.c05502a6.png";